export const PAYMENT_ID = {
  ATM: "atm",
  CARD: "card",
  TRANSFER: "transfer",
  COD: "cod",
  RECEIVE: "receivable",
  QR: "qr",
  PROMOTION: "promotion",
}

export const PAYMENT_PROVIDER = {
  MOMO: 'momo',
  ZALOPAY: 'zalopay',
  STRIPE: 'stripe',
  ACB: 'acb',
  FUNDIIN: 'fundiin',
  APPOTA: 'appota',
  ONEPAY: 'onepay',
  KLARNA: 'klarna',
  GOOGLE: 'google',
  APPLE: 'apple',
  PAYPAL: 'paypal',
  STRIPE_GOOGLE: "stripe_google",
  STRIPE_APPLE: "stripe_apple",
}

export const PAYMENT_METHOD = [
  {
    paymentMethod: PAYMENT_ID.ATM,
    paymentProvider: PAYMENT_PROVIDER.APPOTA,
    label: "checkout_atmCard",
    icon: require("../assets/images/payment/ATM.svg"),
    placeholder: "paymentManagement_yourSavedAtmCards"
  },
  {
    paymentMethod: PAYMENT_ID.CARD,
    paymentProvider: PAYMENT_PROVIDER.APPOTA,
    label: "checkout_creditPayment",
    icon: require("../assets/images/payment/CreditDebit.svg"),
    placeholder: "paymentManagement_yourSavedCreditDebitCards"
  },
  {
    paymentMethod: PAYMENT_ID.ATM,
    paymentProvider: PAYMENT_PROVIDER.ONEPAY,
    label: "checkout_atmCard",
    icon: require("../assets/images/payment/ATM.svg"),
    placeholder: "paymentManagement_yourSavedAtmCards"
  },
  {
    paymentMethod: PAYMENT_ID.CARD,
    paymentProvider: PAYMENT_PROVIDER.ONEPAY,
    label: "checkout_creditPayment",
    icon: require("../assets/images/payment/CreditDebit.svg"),
    placeholder: "paymentManagement_yourSavedCreditDebitCards"
  },
  {
    paymentMethod: PAYMENT_ID.PROMOTION,
    paymentProvider: PAYMENT_PROVIDER.ONEPAY,
    label: "checkout_paymentPromotion",
    icon: require("../assets/images/payment/Partner.jpg"),
    autoOpen: true,
    description: "checkout_paymentPromotionDescription"
  },
  {
    paymentMethod: PAYMENT_ID.QR,
    paymentProvider: PAYMENT_PROVIDER.ONEPAY,
    icon: require("../assets/images/payment/eWallet.svg"),
    label: "checkout_eWallet",
  },
  {
    paymentMethod: PAYMENT_ID.CARD,
    paymentProvider: PAYMENT_PROVIDER.STRIPE,
    label: "checkout_creditPayment",
    icon: require("../assets/images/payment/CreditDebit.svg"),
    placeholder: "paymentManagement_yourSavedCreditDebitCards"
  },
  {
    paymentMethod: PAYMENT_ID.TRANSFER,
    paymentProvider: PAYMENT_PROVIDER.ACB,
    label: "checkout_payBank",
    icon: require("../assets/images/payment/BankTransfer.svg"),
  },
  {
    paymentMethod: PAYMENT_ID.RECEIVE,
    paymentProvider: PAYMENT_PROVIDER.FUNDIIN,
    label: "checkout_fundiin",
    icon: require("../assets/images/payment/Fundiin.jpg"),
    note: true,
    // discount: "₫30.000"
  },
  {
    paymentMethod: PAYMENT_ID.COD,
    label: "checkout_cod",
    icon: require("../assets/images/payment/COD.svg"),
  },
  {
    paymentMethod: PAYMENT_ID.RECEIVE,
    paymentProvider: PAYMENT_PROVIDER.KLARNA,
    label: "checkout_klarna",
    icon: "https://static.openfintech.io/vendors/klarna/icon.svg?w=278&c=v0.59.26#w100"
  },
  {
    paymentMethod: PAYMENT_ID.RECEIVE,
    paymentProvider: PAYMENT_PROVIDER.GOOGLE,
    label: "checkout_google",
    icon: require("../assets/images/payment/google-pay.svg"),
  },
  {
    paymentMethod: PAYMENT_ID.RECEIVE,
    paymentProvider: PAYMENT_PROVIDER.APPLE,
    label: "checkout_apple",
    icon: require("../assets/images/login/login-apple.svg"),
  },
  {
    paymentMethod: PAYMENT_ID.RECEIVE,
    paymentProvider: PAYMENT_PROVIDER.PAYPAL,
    label: "checkout_paypal",
    icon: require("../assets/images/payment/paypal.svg"),
  },
  {
    paymentMethod: PAYMENT_ID.RECEIVE,
    paymentProvider: PAYMENT_PROVIDER.STRIPE_GOOGLE,
    icon: require("../assets/images/payment/google-pay.svg"),
    label: "checkout_google",
    isHide: true,
  },
  {
    paymentMethod: PAYMENT_ID.RECEIVE,
    paymentProvider: PAYMENT_PROVIDER.STRIPE_APPLE,
    label: "checkout_apple",
    icon: require("../assets/images/login/login-apple.svg"),
    isHide: true,
  },
]


export const APPOTA_BANK_LIST = [
  {
    "bankCode": "VCB",
    "bankName": "Vietcombank",
    "icon": require("../assets/images/bank/VCB.jpg")
  },
  {
    "bankCode": "TECHCOMBANK",
    "bankName": "Techcombank",
    "icon": require("../assets/images/bank/TECHCOMBANK.jpg")
  },
  {
    "bankCode": "TPBANK",
    "bankName": "TienphongBank",
    "icon": require("../assets/images/bank/TPBANK.jpg")
  },
  {
    "bankCode": "VIETINBANK",
    "bankName": "Vietinbank",
    "icon": require("../assets/images/bank/VIETINBANK.jpg")
  },
  {
    "bankCode": "VIB",
    "bankName": "VIBank",
    "icon": require("../assets/images/bank/VIB.jpg")
  },
  {
    "bankCode": "DAB",
    "bankName": "Dong A Bank",
    "icon": require("../assets/images/bank/DAB.jpg")
  },
  {
    "bankCode": "HDBANK",
    "bankName": "HD Bank",
    "icon": require("../assets/images/bank/HDBANK.jpg")
  },
  {
    "bankCode": "MB",
    "bankName": "MB",
    "icon": require("../assets/images/bank/MB.jpg")
  },
  {
    "bankCode": "VIETABANK",
    "bankName": "Việt Á Bank",
    "icon": require("../assets/images/bank/VIETABANK.jpg")
  },
  {
    "bankCode": "MARITIMEBANK",
    "bankName": "MARITIMEBANK",
    "icon": require("../assets/images/bank/MARITIMEBANK.jpg")
  },
  {
    "bankCode": "EXIMBANK",
    "bankName": "EximBank",
    "icon": require("../assets/images/bank/EXIMBANK.jpg")
  },
  {
    "bankCode": "SHB",
    "bankName": "SHB",
    "icon": require("../assets/images/bank/SHB.jpg")
  },
  {
    "bankCode": "VPBANK",
    "bankName": "VP Bank",
    "icon": require("../assets/images/bank/VPBANK.jpg")
  },
  {
    "bankCode": "ABBANK",
    "bankName": "AB Bank",
    "icon": require("../assets/images/bank/ABBANK.jpg")
  },
  {
    "bankCode": "SACOMBANK",
    "bankName": "Sacombank",
    "icon": require("../assets/images/bank/SACOMBANK.jpg")
  },
  {
    "bankCode": "NAMA",
    "bankName": "Nam A Bank",
    "icon": require("../assets/images/bank/NAMA.jpg")
  },
  {
    "bankCode": "OCEANBANK",
    "bankName": "OceanBank",
    "icon": require("../assets/images/bank/OCEANBANK.jpg")
  },
  {
    "bankCode": "BIDV",
    "bankName": "BIDV",
    "icon": require("../assets/images/bank/BIDV.jpg")
  },
  {
    "bankCode": "SEABANK",
    "bankName": "SeaBank",
    "icon": require("../assets/images/bank/SEABANK.jpg")
  },
  {
    "bankCode": "BACA",
    "bankName": "Ngân hàng Bắc A",
    "icon": require("../assets/images/bank/BACA.jpg")
  },
  {
    "bankCode": "NAVIBANK",
    "bankName": "NaviBank",
    "icon": require("../assets/images/bank/NAVIBANK.jpg")
  },
  {
    "bankCode": "AGRIBANK",
    "bankName": "Agribank",
    "icon": require("../assets/images/bank/AGRIBANK.jpg")
  },
  {
    "bankCode": "SAIGONBANK",
    "bankName": "Ngân hàng Sài Gòn Công Thương",
    "icon": require("../assets/images/bank/SAIGONBANK.jpg")
  },
  {
    "bankCode": "PVBANK",
    "bankName": "PVcombank",
    "icon": require("../assets/images/bank/PVBANK.jpg")
  },
  {
    "bankCode": "ACB",
    "bankName": "Ngân hàng ACB",
    "icon": require("../assets/images/bank/ACB.jpg")
  },
  {
    "bankCode": "LPB",
    "bankName": "Ngân hàng Bưu Điện",
    "icon": require("../assets/images/bank/LPB.jpg")
  },
  {
    "bankCode": "BVBANK",
    "bankName": "Ngân hàng Bảo Việt",
    "icon": require("../assets/images/bank/BVBANK.jpg")
  },
  {
    "bankCode": "OCB",
    "bankName": "Ngân hàng Phương Đông (OCB)",
    "icon": require("../assets/images/bank/OCB.jpg")
  },
  {
    "bankCode": "KIENLONGBANK",
    "bankName": "Ngân hàng Kiên Long",
    "icon": require("../assets/images/bank/KIENLONGBANK.jpg")
  },
  {
    "bankCode": "VRB",
    "bankName": "Ngân hàng Việt Nga",
    "icon": require("../assets/images/bank/VRB.jpg")
  },
  {
    "bankCode": "NCB",
    "bankName": "Ngân hàng Quốc Dân",
    "icon": require("../assets/images/bank/NCB.jpg")
  },
  {
    "bankCode": "PGBANK",
    "bankName": "PG bank",
    "icon": require("../assets/images/bank/PGBANK.jpg")
  },
  {
    "bankCode": "GPBANK",
    "bankName": "GP Bank",
    "icon": require("../assets/images/bank/GPBANK.jpg")
  },
  // {
  //   "bankCode": "JCB",
  //   "bankName": "Thẻ JCB",
  //   "icon": require("../assets/images/bank/JCB.jpg")
  // },
  // {
  //   "bankCode": "SCB",
  //   "bankName": "Ngân hàng TPTM Sài Gòn",
  //   "icon": require("../assets/images/bank/SCB.jpg")
  // },
  // {
  //   "bankCode": "WOORIBANK",
  //   "bankName": "Ngân hàng Wooribank",
  //   "icon": require("../assets/images/bank/WOORIBANK.jpg")
  // },
  {
    "bankCode": "VIETCAPITALBANK",
    "bankName": "Ngân hàng Bản Việt",
    "icon": require("../assets/images/bank/VIETCAPITALBANK.jpg")
  }
];

export const APPOTA_CARD_LIST = [
  {
    "bankCode": "MASTERCARD",
    "bankName": "Thẻ Master Card",
    "icon": require("../assets/images/bank/MASTERCARD.jpg")
  },
  {
    "bankCode": "VISA",
    "bankName": "Thẻ Visa",
    "icon": require("../assets/images/bank/VISA.jpg")
  },
  // {
  //   "bankCode": "JCB",
  //   "bankName": "Thẻ JCB",
  //   "icon": require("../assets/images/bank/JCB.jpg")
  // },
]